import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import { ViewVariant } from "@/common/ts/layout";
import { EntityType, VehicleDamageDto } from "@/core/api/generated/v1";

import GeneralHistoryPaginatedList from "../../../GeneralHistory/ListView/GeneralHistoryPaginatedList";

interface Props {
  entity: VehicleDamageDto;
}

export default function GeneralHistoryTabContent({ entity }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <AuthorizedTenantElement tenantIds={[entity?.tenantId]}>
          <GeneralHistoryPaginatedList
            defaultValues={{
              subjectEntityType: EntityType.VehicleDamage,
              subjectEntityId: entity.id,
            }}
            displayProps={{
              viewVariant: ViewVariant.Tab,
            }}
          />
        </AuthorizedTenantElement>
      </ViewContentBlock>
    </PageTabContent>
  );
}
